import { GenIcon, type IconBaseProps } from "react-icons";

/**
 * Lucide icons that react-icons does not ship yet.
 *
 * react-icons' Lucide set lags behind Lucide itself (5.7.0 has no shield-user).
 * These are Lucide's own SVGs (ISC licence), built with the same GenIcon
 * react-icons uses, so they take the same props and drop into Chakra's
 * `<Icon as={...}>` like any `Lu*` icon. Replace each with its `Lu*` import
 * once react-icons has it.
 */

// https://lucide.dev/icons/shield-user
export function LuShieldUser(props: IconBaseProps) {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
    child: [
      { tag: "path", attr: { d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" }, child: [] },
      { tag: "path", attr: { d: "M6.376 18.91a6 6 0 0 1 11.249.003" }, child: [] },
      { tag: "circle", attr: { cx: "12", cy: "11", r: "4" }, child: [] },
    ],
  })(props);
}
